import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import OverseerModalSupport from 'shared/ui/icons/OverseerModalSupport';
import Telegram from 'shared/ui/icons/Telegram';
import { isTranslate } from 'shared/lib/lang';

import {PALETTE} from 'shared/config/model/palette';
import {runtimeEnv} from 'shared/lib/runtimeEnv';

import SupportForm from './SupportForm/SupportForm';

import styles from './SupportModal.module.scss';

interface ITariffModalProps {
    open: boolean,
    handleClose: () => void;
}

const SupportModal: React.FC<ITariffModalProps> = ({open, handleClose}) => {

    // eslint-disable-next-line max-len
    const SUPPORT_TEXT= t`Если возникла проблема или есть идея, заполните форму или обратитесь напрямую – это помогает нам развивать продукт.`

    return (
        <MainModal
            header={
                <div className={styles.containerTitle}>
                    <span className={styles.title}>
                        {t`Служба поддержки`}
                    </span>
                    <div className={styles.subTitleContainer}>
                        {
                            isTranslate()
                                ? <></>
                                : <span className={styles.icon}>
                                    <OverseerModalSupport />
                                </span>
                        }
                        <div className={styles.content}>
                            <span className={styles.text}>
                                {SUPPORT_TEXT}
                            </span>
                            {
                                isTranslate()
                                    ? <></>
                                    : <div className={styles.action}>
                                        <span className={styles.actionIcon}>
                                            <Telegram color={PALETTE.telegram}/>
                                        </span>
                                        <a
                                            className={styles.actionLink}
                                            href={AppUrls.TELEGRAM}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            @{runtimeEnv('REACT_APP_SUPPORT_TELEGRAM')}
                                        </a>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            }
            open={open}
            handleClose={handleClose}
            size="md"
        >
            <SupportForm onClose={handleClose}/>
        </MainModal>
    );
};

export default SupportModal;